<template>
<div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
    <div id="TituloDetalleDeDocumento_div">
        <h5  class="label-black" style="margin-bottom: 0px;">SOLICITUDES</h5>
        <h6  class="label-black" style="margin-top: 0px;">Consulta de Solicitudes</h6>
    </div>

    <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
            <div class="area custom-area">
                <div v-if="usrConsulta.Area.AreaId != 21">
                    <!-- <h6>Consulta de Solicitudes</h6>
                    <hr /> -->
                    <!-- <div class="form-group" id="solicitud_div">
                        <label>Solicitud:</label>
                        <input class="form-control" type="number" placeholder="No. Solicitud" v-model="Busqueda.NoSolicitud"/>
                    </div>
                    <div id="BotonBusqueda_div" class="text-right">
                        <button class="btn btn-dark"  @click='BuscaSolicitud()'>Buscar Solicitud</button>
                    </div> -->
                    <div class="form-group" id="solicitud_div">
                        <label class="label-black">Fecha de Solicitudes:</label>
                        <input class="form-control" type="date" v-model="Busqueda.Fecha"/>
                    </div>
                    <div id="BotonBusqueda_div" class="text-right">
                        <button class="btn btn-sm btn-custom"  @click='BuscaFecha()'>Buscar por fecha</button>
                    </div>
                </div>
                <div v-if="usrConsulta.Area.AreaId == 21"> 
                    <div class="form-group" id="solicitud_div">
                        <label class="label-black">Fecha de Solicitudes:</label>
                        <input class="form-control" type="date" v-model="Busqueda.Fecha"/>
                    </div>
                    <div id="componente_Area">
                        <label class="label-black">Área</label>
                        <CAreas
                        v-on:valorParaElPadre="cambioDeArea" 
                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                        :idDelInput="'filtroDeBusqueda_Area'" 
                        :parametros="Busqueda.parametros_Area" 
                        :valorDefinido="Busqueda.parametros_Area.areaId" 
                        
                        >
                        </CAreas>
                    </div>
                    <div id="BotonBusqueda_div" class="text-right">
                        <button class="btn btn-sm btn-custom"  @click='BuscaFecha()'>Buscar por fecha</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="this.AreaSolicitud == true && this.AreaFecha == false">
            <div class="area custom-area">
                <div>
                    <h6 class="label-black">Datos de Solicitud</h6>
                    <hr>
                </div>
                <div class="row">
                    <div class="form-group col-4" id="solicitud_div">
                        <label class="label-black">No. Solicitud</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.SolicitudDocumentoId"/>
                    </div>
                    <div class="form-group col-4" id="fecha_div">
                        <label class="label-black">Fecha de Registro</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.FechaRegistro"/>
                    </div>
                    <div class="form-group col-4" id="Estatus_div">
                        <label class="label-black">Estatus de Solicitud</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.TipoEstatusSolicitud.Nombre"/>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12" id="Año_div">
                        <label class="label-black">Observaciones de Archivo:</label>
                        <textarea type="text" class="form-control" readonly v-model="Solicitud.ObservacionesArchivo" rows="2"/>
                    </div>
                </div>
            </div>
            <div class="area custom-area">
                <div>
                    <h6 class="label-black">Datos del Documento</h6>
                    <hr>
                </div>
                 <div class="row">
                    <div class="form-group col-4" id="Area_div">
                        <label class="label-black">Área</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.InventarioDocumentos.Area.Nombre"/>
                    </div>
                    <div class="form-group col-4" id="Documento_div">
                        <label class="label-black">Tipo de Documento</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.InventarioDocumentos.TipoDocumento.Nombre"/>
                    </div>
                   <div class="form-group col-4" id="Materia_div" v-if="Solicitud.InventarioDocumentos.Materia != null">
                        <label class="label-black">Materia</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.InventarioDocumentos.Materia.Nombre"/>
                    </div>
                    <div class="form-group col-4" id="Materia_div" v-else>
                        <label class="label-black">Materia</label>
                        <input type="text" class="form-control" readonly />
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-4" id="Año_div">
                        <label class="label-black">Año</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.InventarioDocumentos.Anio"/>
                    </div>
                    <div class="form-group col-4" id="Consecutivo_div">
                        <label class="label-black">Consecutivo</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.InventarioDocumentos.Consecutivo"/>
                    </div>
                </div>
                
            </div>
            <div class="area custom-area" v-if="Solicitud.Juzgado != null">
                <div>
                    <h6 class="label-black">Solicitante del Poder Judicial</h6>
                    <hr>
                </div>
                <div class="row" v-if="Solicitud.Juzgado.UsuarioIdQuienSolicita != null">
                    <div class="form-group col-4" id="Nombre_div" >
                        <label class="label-black">Nombre</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.Juzgado.UsuarioIdQuienSolicita.Nombre"/>
                    </div>
                    <div class="form-group col-4" id="ApPaterno_div">
                        <label class="label-black">Apellido Paterno</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno"/>
                    </div>
                    <div class="form-group col-4" id="ApMaterno_div">
                        <label class="label-black">Apellido Materno</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno"/>
                    </div>
                </div>
                <div class="row">
                        <div class="form-group col-8" id="Area_div">
                        <label class="label-black">Área</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.Juzgado.AreaIdQueSolicita.Nombre"/>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12" id="Año_div">
                        <label class="label-black">Observaciones del Área Solicitante:</label>
                        <textarea type="text" class="form-control" readonly v-model="Solicitud.ObservacionesJuzgado" rows="2"/>
                    </div>
                </div>
            </div>
            <div class="area custom-area" v-else>
                <div>
                    <h6 class="label-black">Solicitante Público</h6>
                    <hr>
                </div>
                <div class="row">
                    <div class="form-group col-4" id="Nombre_div">
                        <label class="label-black">Nombre</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.Publica.Nombre"/>
                    </div>
                    <div class="form-group col-4" id="ApPaterno_div">
                        <label class="label-black">Apellido Paterno</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.Publica.ApellidoPaterno"/>
                    </div>
                    <div class="form-group col-4" id="ApMaterno_div">
                        <label class="label-black">Apellido Materno</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.Publica.ApellidoMaterno"/>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-4" id="TipoIdentificacion_div">
                        <label class="label-black">Tipo de Identificación</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.Publica.TipoIdentificacion.Nombre"/>
                    </div>
                    <div class="form-group col-4" id="ApPaterno_div">
                        <label class="label-black">Numero de Identificación</label>
                        <input type="text" class="form-control" readonly v-model="Solicitud.Publica.NumeroIdentificacion"/>
                    </div>
                </div>
            </div>
            <div class="area custom-area">
                <div>
                    <h6 class="label-black">Volumenes en la Solicitud</h6>
                    <hr>
                </div>
                <div id="Volumenes_table" class="table-reponsive">
                    <table class="table table-striped table-light table-hover">
                        <thead class="thead-custom">
                            <tr>
                                <th>Numero de Volumen</th>
                                <th>Fojas</th>
                                <th>Ubicación</th>
                            </tr>
                        </thead>
                        <tbody class="text-dark">
                            <tr v-for="Lista in Solicitud.VolumenesEnSolicitud" :key="Lista.Volumenes.VolumenId">
                                <td>{{Lista.Volumenes.NumVolumen}}</td>
                                <td>{{Lista.Volumenes.Fojas}}</td>
                                <td>{{Lista.Volumenes.Area.Nombre}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="text-right" v-if="Solicitud !=null && AreaActual ==21">
                    <button class="btn btn-sm btn-custom" @click='ImprimirSolicitud(Solicitud, usrConsulta)' >Imprimir Solicitud</button>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-else-if="this.AreaFecha==true && this.AreaSolicitud==false">
            <div class="area custom-area">
                <div>
                    <h6 class="label-black">Listado de Solicitudes registradas el {{EtiquetaFecha}} en {{AreaEtiqueta}}, Total : {{ListadoSolicitudes.length}}</h6>
                </div>
                <div id="solicitudes_table" class="table-responsive">
                    <table class="table table-striped table-light table-hover table-sm">
                        <thead class="thead-custom">
                            <tr>
                                <th>#</th>
                                <th>Documento</th>
                                <th>Consecutivo</th>
                                <th>Sede</th>
                                <th>Solicitado por:</th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="text-dark" v-for="Lista in ListadoSolicitudes" :key="Lista.SolicitudDocumentoId">
                            <tr>
                                <td >
                                    <p class="text-danger" v-if="Lista.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId==5">{{Lista.SolicitudDocumentoId}}</p>
                                    <p class="text-success" v-else-if="(Lista.ObservacionesArchivo!=null && Lista.ObservacionesArchivo!='' ) && Lista.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId!=4">{{Lista.SolicitudDocumentoId}}</p>
                                    <p class="text-dark" v-else>{{Lista.SolicitudDocumentoId}}</p>
                                </td>
                                <td >{{Lista.InventarioDocumentos.TipoDocumento.Nombre}}</td>
                                <td >{{Lista.InventarioDocumentos.Consecutivo}}/{{Lista.InventarioDocumentos.Anio}}</td>
                                <td >{{Lista.InventarioDocumentos.SedeArchivo.Nombre}}</td>
                                <td >{{Lista.Juzgado.UsuarioIdQuienSolicita.Nombre}} {{Lista.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno}} {{ Lista.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno}}</td>
                                <td v-if="Lista.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId==2 && usrConsulta.Area.AreaId==21">
                                    <a v-on:click="accionDevolver(Lista)" title="Regresar Estatus a Solicitud">
                                        <i class="fas fa-undo"></i>
                                    </a>
                                </td>
                                <td v-else>
                                </td>
                                <td v-if="Lista.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId==2 && usrConsulta.Area.AreaId==21">
                                    <a v-on:click="ImprimirVale(Lista)" title="Imprimir Vale">
                                        <i class="fas fa-print"></i>
                                    </a>
                                </td>
                                <td v-else>
                                </td>
                                <td v-if="Lista.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId==2 && usrConsulta.Area.AreaId==21">
                                    <a v-on:click="Anexos(Lista)" title="Modificar Anexos">
                                        <i class="fas fa-pen"></i>
                                    </a>
                                </td>
                                <td v-else>
                                </td>
                            </tr>
                            
                        </tbody>
                    </table>

                </div>
                <div v-if="this.Arch_Observaciones==true" id="observacionesArchivo">
                    <ObsArchivo :Id="this.idModal" :Detalle="this.ObsModal" @dialogo='EstatusObservaciones($event)'></ObsArchivo>
                </div>
                <div class="text-left" v-if="ListadoSolicitudes.length>0 && usrConsulta.Area.AreaId!=21">
                         <button class="btn btn-sm btn-custom" @click='ImprimirListado(ListadoSolicitudes, usrConsulta)' >Imprimir Listado</button>
                </div>
                <div class="text-left" v-if="ListadoSolicitudes.length>0 && usrConsulta.Area.AreaId==21">
                         <button class="btn btn-sm btn-custom" @click='GenerarPrintVales(ListadoSolicitudes, UsuarioArchivo)' >Imprimir Acuse</button>
                </div>
            </div>
        </div>
    </div>
</div>
    
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import LogoPJE from '@/../src/assets/Logotipo_Positivo_Vertical-recibo.png'
import Contenido from '@/components/ArchivoJudicial/Comun/ComentarioSolicitud.vue'

export default {
    components: {
        CAreas: catalogos.ArchivoJudicial.C001Areas,
        ObsArchivo: Contenido
    }, 
    data(){
        return{
            enumeraciones,
            Busqueda:{
                NoSolicitud : null,
                Fecha: null,
                parametros_Area: {
                        areaId: -1,
                        Nombre: "",
                        conMaterias: true,
                        Materias: [ { MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 6, Activo: true }, { MateriaId: 9, Activo: true }, { MateriaId: 13, Activo: true } ]
                    }
            },
            Solicitud:{
                SolicitudDocumentoId: null,
                InventarioDocumentoId: 0,
                FechaRegistro: null,
                InventarioDocumentos: {
                    Area: {
                        AreaId: 0,
                        Nombre: ""
                    },
                    Materia: {},
                    TipoDocumento: {
                        TipoDocumentoId: 0,
                        Nombre: ""
                    },
                    Anio: "",
                    Consecutivo: ""
                },
                TipoEstatusSolicitud: {
                    TipoEstatusSolicitudId: 0,
                    Nombre:""
                },
                Juzgado: {
                    SolicitudJuzgadoId: null,
                    UsuarioIdQuienSolicita: {
                        IdUsuario: null,
                        Nombre: "",
                        ApellidoParteno: "",
                        ApellidoMaterno: "",
                    },
                    AreaIdQueSolicita: {
                        AreaId: null,
                        Nombre: ""
                    }
                },
                Publica: {},
                VolumenesEnSolicitud:[],
                ObservacionesArchivo: "",
                ObservacionesJuzgado: ""
            },
            AreaSolicitud: false,
            AreaFecha:false,
            ListadoSolicitudes :[],
            usrConsulta: {
                Area: {AreaId:0}
            },
            AreaEtiqueta:"",
            EtiquetaFecha: "",
            AreaActual: 0,
            UsuarioArchivo :{},
            Arch_Observaciones: false,
            ObsModal:"",
            SecretarioAcuerdos: "",
            PuestoFirma : ""
        }
    },
    methods: {
        accionDevolver(datos)
        {   let _this= this;
            
            const header = this.$store.state.Login_AutorizacionOriginal;
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "¿Desea Regresar Estatus en Solicitud?",
                buttons: {
                cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
            }
            },
            callback: function (regreso) {
                if (regreso) {
                    
                    var SolicitudesAutorizadas = [];
                    SolicitudesAutorizadas.push(
                        {
                            "SolicitudDocumentoId": datos.SolicitudDocumentoId,
                            "InventarioDocumentoId": datos.InventarioDocumentoId,
                            "TipoEstatusSolicitud": {"TipoEstatusSolicitudDocumentoId": 1},
                            "VolumenesEnSolicitud": datos.VolumenesEnSolicitud,
                            "IncidentesEnSolicitud": datos.IncidentesEnSolicitud,
                            "TerceriasEnSolicitud": datos.TerceriasEnSolicitud,
                            "ObservacionesArchivo": datos.ObservacionesArchivo,
                        }
                    )
                    var MovimientosDocumentos =[];
                    var MovimientosACerrar = [];

                            // if(datos.VolumenesEnSolicitud!=null && datos.VolumenesEnSolicitud.length>0){
                            //     $.each(datos.VolumenesEnSolicitud, function (indice, volsId){
                            //         MovimientosDocumentos.push({
                            //             VolumenId : volsId.VolumenId,
                            //             IncidenteId: null,
                            //             TerceriaId: null,
                            //             FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                            //             TiposMovimientos: {"TipoMovimientoId": 1},
                            //             UsuarioQuienPresta: {"IdUsuario" : volsId.Volumenes.MovimientoVolumen.UsuarioQuienRecibe.IdUsuario},
                            //             UsuarioQuienRecibe: {"IdUsuario" : volsId.Volumenes.MovimientoVolumen.UsuarioQuienPresta.IdUsuario},
                            //             AreaQuePresta : {"AreaId" : volsId.Volumenes.MovimientoVolumen.AreaQueRecibe.AreaId},
                            //             AreaQueRecibe : {"AreaId" : volsId.Volumenes.MovimientoVolumen.AreaQuePresta.AreaId},
                            //             SolicitudDocumentoId: datos.SolicitudDocumentoId,
                            //             Observaciones: "Movimiento de Cambio de Prestamo a Estado Solicitud, en solicitud No. " + datos.SolicitudDocumentoId
                            //         });
                            //         MovimientosACerrar.push({
                            //             "MovimientoDocumentoId": volsId.Volumenes.MovimientoVolumen.MovimientoDocumentoId,
                            //             "UsuarioQuienRecibe" : volsId.Volumenes.MovimientoVolumen.UsuarioQuienRecibe
                            //         })
                            // });
                            // }
                            
                            //  if(datos.IncidentesEnSolicitud!=null && datos.IncidentesEnSolicitud.length>0){
                            //     $.each(datos.IncidentesEnSolicitud, function (indice, volsId){
                            //         MovimientosDocumentos.push({
                            //             VolumenId : null,
                            //             IncidenteId: volsId.IncidenteId,
                            //             TerceriaId: null,
                            //             FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                            //             TiposMovimientos: {"TipoMovimientoId": 1},
                            //             UsuarioQuienPresta: {"IdUsuario" : volsId.Incidentes.MovimientoIncidente.UsuarioQuienRecibe.IdUsuario},
                            //             UsuarioQuienRecibe: {"IdUsuario" : volsId.Incidentes.MovimientoIncidente.UsuarioQuienPresta.IdUsuario},
                            //             AreaQuePresta : {"AreaId" : volsId.Incidentes.MovimientoIncidente.AreaQueRecibe.AreaId},
                            //             AreaQueRecibe : {"AreaId" : volsId.Incidentes.MovimientoIncidente.AreaQuePresta.AreaId},
                            //             SolicitudDocumentoId: datos.SolicitudDocumentoId,
                            //             Observaciones: "Movimiento de Cambio de Prestamo a Estado Solicitud, en solicitud No. " + datos.SolicitudDocumentoId
                            //         });
                            //         MovimientosACerrar.push({
                            //             "MovimientoDocumentoId": volsId.Incidentes.MovimientoIncidente.MovimientoDocumentoId,
                            //             "UsuarioQuienRecibe" : volsId.Incidentes.MovimientoIncidente.UsuarioQuienRecibe
                            //         })
                            // });
                            // }
                            // if(datos.TerceriasEnSolicitud!=null && datos.TerceriasEnSolicitud.length>0){
                            //     $.each(datos.TerceriasEnSolicitud, function (indice, volsId){
                            //         MovimientosDocumentos.push({
                            //             VolumenId : null,
                            //             IncidenteId: null,
                            //             TerceriaId: volsId.TerceriaId,
                            //             FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                            //             TiposMovimientos: {"TipoMovimientoId": 1},
                            //             UsuarioQuienPresta: {"IdUsuario" : volsId.Incidentes.MovimientoIncidente.UsuarioQuienRecibe.IdUsuario},
                            //             UsuarioQuienRecibe: {"IdUsuario" : volsId.Incidentes.MovimientoIncidente.UsuarioQuienPresta.IdUsuario},
                            //             AreaQuePresta : {"AreaId" : volsId.Incidentes.MovimientoIncidente.AreaQueRecibe.AreaId},
                            //             AreaQueRecibe : {"AreaId" : volsId.Incidentes.MovimientoIncidente.AreaQuePresta.AreaId},
                            //             SolicitudDocumentoId: datos.SolicitudDocumentoId,
                            //             Observaciones: "Movimiento de Cambio de Prestamo a Estado Solicitud, en solicitud No. " + datos.SolicitudDocumentoId
                            //         });
                            //         MovimientosACerrar.push({
                            //             "MovimientoDocumentoId": volsId.Incidentes.MovimientoIncidente.MovimientoDocumentoId,
                            //             "UsuarioQuienRecibe" : volsId.Incidentes.MovimientoIncidente.UsuarioQuienRecibe
                            //         })
                            // });
                            // }
                    let Eliminar = true;
                    var peticion= { SolicitudesAutorizadas, MovimientosDocumentos, MovimientosACerrar , Eliminar}
                   
                    //llamamos api para cambiar estatus a solicitud y devolver movimientos
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(api.conexion + api.ArchivoJudicial.CambiaEstadoSolicitud, peticion, comun.CrearElHeaderDeAutorizacion(header)
                    ).then(respuesta => {
                    if(respuesta.data.SiHayError)
                            {
                                console.log(respuesta);
                                comun.SeEstaCargandoInformacion(false);
                                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            }
                        else
                            {
                                comun.mensajeDeAlerta("Se ha cambiado el Estado de La Solicitud", null, null);
                                _this.Busqueda.Fecha= datos.FechaRegistro;
                                _this.Busqueda.parametros_Area.areaId= datos.Juzgado.AreaIdQueSolicita.AreaId;
                                _this.BuscaFecha();
                            }
                    comun.SeEstaCargandoInformacion(false);
                    }).catch(excepcion => {
                        console.log(excepcion);
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    });
                    //actualizamos consulta

                }
            }
            });
        },
        cambioDeArea(datos){
            this.Busqueda.parametros_Area.areaId = parseInt(datos[0].target.value);
            this.Busqueda.parametros_Area.Nombre = datos[0].target.selectedOptions[0].text
        },
        BuscaSolicitud(){
            this.ListadoSolicitudes =[];
            this.$nextTick(()=> { PaginarTabla('solicitudes_table', 0)});
            if(this.Busqueda.NoSolicitud != null || this.Busqueda.NoSolicitud != undefined)
            {
                var peticion = {
                    "SolicitudDocumentoId" : this.Busqueda.NoSolicitud,
                    "FechaListado": null,
                    "AreaConsulta": 0
                };
                
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.ConsultaSolicitud, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                    if(respuesta.data.SiHayError)
                    {
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.LimpiaBusqueda();
                    }
                    else
                    {   
                        comun.SeEstaCargandoInformacion(false);
                        this.Solicitud= respuesta.data.Solicitud;
                        this.Solicitud.FechaRegistro = moment(respuesta.data.Solicitud.FechaRegistro).format('DD-MM-YYYY HH:mm');
                        this.AreaFecha = false;
                        this.AreaSolicitud = true;
                        this.LimpiaBusqueda();
                        
                    }
                    comun.SeEstaCargandoInformacion(false);
                    })
                .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                
                })
            }
            else{
                comun.mensajeDeAlerta("No hay parametros de busqueda de solictud", null, null);
            }
        },
        LimpiaBusqueda (){
            this.Busqueda.NoSolicitud = null;
            //this.Busqueda.Fecha= null;
            //this.Busqueda.parametros_Area.areaId = -1
        },
        BuscaFecha(){
           var Hoy = moment().format('YYYY-MM-DD');
           if(this.ValidaBusquedaFecha())
           {
               let areaDefinida = 0;
               if(this.usrConsulta.Area.AreaId!=21)
               {
                areaDefinida = this.usrConsulta.Area.AreaId
               }
               else
               {
                areaDefinida =this.Busqueda.parametros_Area.areaId
               }
                   // Obtencion de Listado
                var peticion = {
                    "SolicitudDocumentoId" : null,
                    "FechaListado": this.Busqueda.Fecha,
                    "AreaConsulta": areaDefinida //this.Busqueda.parametros_Area.areaId
                    };
                this.AreaEtiqueta = this.usrConsulta.Area.AreaId==21 ? this.Busqueda.parametros_Area.Nombre : this.usrConsulta.Area.Nombre;
                this.EtiquetaFecha = moment(this.Busqueda.Fecha).format('DD/MM/YYYY');
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(api.conexion + api.ArchivoJudicial.ConsultaSolicitud, peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                    if(respuesta.data.SiHayError)
                        {
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            this.LimpiaBusqueda();
                        }
                    else
                        {   
                            comun.SeEstaCargandoInformacion(false);
                            var arrayObtenida = respuesta.data.ListadoSolicitudesFecha;
                            
                            //console.log(arrayObtenida)
                            this.UsuarioArchivo =  respuesta.data.usrConsulta;
                            this.ListadoSolicitudes= arrayObtenida.sort((a,b)=>(a.InventarioDocumentos.CodigoBarras>b.InventarioDocumentos.CodigoBarras? 1:-1))
                            
                            if (this.ListadoSolicitudes.length==0)
                            {
                                comun.mensajeDeAlerta("No hay solicitudes en fecha seleccionada para este juzgado", null, null);
                            };
                            if(this.ListadoSolicitudes.length>20)
                            {
                                this.$nextTick(()=> { PaginarTabla('solicitudes_table', 20)});
                            }
                            this.AreaFecha = true;
                            this.AreaSolicitud = false;
                            this.LimpiaBusqueda();
                            this.SecretarioAcuerdos = respuesta.data.SecretarioAcuerdos;
                            this.PuestoFirma = respuesta.data.PuestoFirma
                            
                        }
                    comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros ", excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                        });
           };
           
            this.AreaSolicitud = false,
            this.AreaFecha= true;
        },
        ObtieneArea(){
             var peticion = {
                    "SolicitudDocumentoId" : null,
                    "FechaListado": null
                        };
                    
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(api.conexion + api.ArchivoJudicial.ConsultaSolicitud, peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                    if(respuesta.data.SiHayError)
                        {
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            this.LimpiaBusqueda();
                        }
                    else
                        {   
                            comun.SeEstaCargandoInformacion(false);
                            this.usrConsulta = respuesta.data.usrConsulta;
                            this.AreaActual = this.usrConsulta.AreaAsignado.AreaId;
                        }
                    comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros ", excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                        });
        },
        ValidaBusquedaFecha(){
            if (this.Busqueda.Fecha == null)
            {
                comun.mensajeDeAlerta("Determine una Fecha para obtener listado en Consulta", null, null);
                return false;
            };
            if(this.Busqueda.parametros_Area.areaId <0 && this.usrConsulta.Area.AreaId==21)
            {
                comun.mensajeDeAlerta("Determine un área de Consulta", null, null);
                return false;
            };
            return true;
        },
        ImprimirListado(Listado, usrArchivo){
            var UsuariosFirmas =[];
            //UsuariosFirmas.push({"Nombre": usrArchivo.Nombre, "ApPaterno": usrArchivo.ApellidoPaterno, "ApMaterno": usrArchivo.ApellidoMaterno, "Area": usrArchivo.AreaAsignado.Nombre});
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">LISTADO DE SOLICITUDES REGISTRADAS</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h6 class="text-center">FECHA DE REGISTRO: '+ this.EtiquetaFecha +'</h6>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 text-right">');
            printWin.document.write('<label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 ">');
            printWin.document.write('<label>Area: '+ this.AreaEtiqueta +'</label>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12">');
            printWin.document.write('<div class="table-reponsive">');
            printWin.document.write('<table class="table table-striped table-light table-hover">');
            printWin.document.write('<thead><tr><th >Solicitud No.</th><th >Documento</th><th >Consecutivo</th><th >Solicitado por:</th>');
            printWin.document.write('<th>Observaciones</th><th>Volumenes en Solicitud</th><th></th></tr></thead><tbody class="text-dark">');
            //ciclo inicio
            $.each(Listado, function(index, SolicitudesImpresion){
                var rows = SolicitudesImpresion.VolumenesEnSolicitud.length + 1;
                var Detalle = SolicitudesImpresion.ObservacionesArchivo !=null ? SolicitudesImpresion.ObservacionesArchivo : "";

                printWin.document.write('<tr>');
                printWin.document.write('<td rowspan="'+ rows +'">'+ SolicitudesImpresion.SolicitudDocumentoId +'</td>');
                printWin.document.write('<td rowspan="'+ rows +'">'+ SolicitudesImpresion.InventarioDocumentos.TipoDocumento.Nombre +'</td>');
                printWin.document.write('<td rowspan="'+ rows +'">'+ SolicitudesImpresion.InventarioDocumentos.Consecutivo +'/' + SolicitudesImpresion.InventarioDocumentos.Anio +'</td>');
                printWin.document.write('<td rowspan="'+ rows +'">'+ SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre 
                                              + ' ' + SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno 
                                              + ' ' + SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno +'</td>');
                printWin.document.write('<td rowspan="'+ rows +'">'+ Detalle +'</td>');
                printWin.document.write('</tr>');
                $.each(SolicitudesImpresion.VolumenesEnSolicitud, function(index, Volumenes)
                {
                    printWin.document.write('<tr>');
                    printWin.document.write('<td>Volumen: '+ Volumenes.Volumenes.NumVolumen + '</td>');
                    printWin.document.write('<td>Fojas: '+ Volumenes.Volumenes.Fojas + '</td>');
                    printWin.document.write('</tr>');
                });
                // var Existe = UsuariosFirmas.findIndex(datos => datos.Nombre == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre &&
                //                                     datos.ApPaterno == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno &&
                //                                     datos.ApMaterno == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno);
                // if(Existe == -1)
                //     {
                //         UsuariosFirmas.push({
                //                 "Nombre": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre, 
                //                 "ApPaterno": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno, 
                //                 "ApMaterno": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno, 
                //                 "Area": SolicitudesImpresion.Juzgado.AreaIdQueSolicita.Nombre
                //                             });
                //     }
                
            });
            //ciclo fin

            printWin.document.write('</tbody></table></div></div></div>');
            // printWin.document.write('<div class="area">');
            // var Cuadros = UsuariosFirmas.length;
            // switch (Cuadros)
            // {
            //     case 2:
            //         {
            //             printWin.document.write('<div class="row">');
            //             printWin.document.write('<div class="form-group col-1"></div>');
            //             printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            //             printWin.document.write('<br><br><br><br><br>');
            //             printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            //             printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[0].Nombre + ' '+ UsuariosFirmas[0].ApPaterno + ' '+ UsuariosFirmas[0].ApMaterno + '</strong></label><div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('       <div class="align-self-center">');
            //             printWin.document.write('           <label><strong>' + UsuariosFirmas[0].Area + '</strong></label></div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('</div>');
            //             printWin.document.write('<div class="form-group col-2"></div>');
            //             printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            //             printWin.document.write('<br><br><br><br><br>');
            //             printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            //             printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[1].Nombre + ' '+ UsuariosFirmas[1].ApPaterno + ' '+ UsuariosFirmas[1].ApMaterno + '</strong></label><div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('       <div class="align-self-center">');
            //             printWin.document.write('           <label><strong>' + UsuariosFirmas[1].Area + '</strong></label></div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('</div>');
            //             printWin.document.write('<div class="form-group col-1"></div>');
            //             printWin.document.write('</div>');
            //             break;
            //         }
            //     case 3:
            //         {
            //             printWin.document.write('<div class="row">');
            //             printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            //             printWin.document.write('<br><br><br><br><br>');
            //             printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            //             printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[0].Nombre + ' '+ UsuariosFirmas[0].ApPaterno + ' '+ UsuariosFirmas[0].ApMaterno + '</strong></label><div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('       <div class="align-self-center">');
            //             printWin.document.write('           <label><strong>' + UsuariosFirmas[0].Area + '</strong></label></div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('</div>');
            //             printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            //             printWin.document.write('<br><br><br><br><br>');
            //             printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            //             printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[1].Nombre + ' '+ UsuariosFirmas[1].ApPaterno + ' '+ UsuariosFirmas[1].ApMaterno + '</strong></label><div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('       <div class="align-self-center">');
            //             printWin.document.write('           <label><strong>' + UsuariosFirmas[1].Area + '</strong></label></div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('</div>');
            //             printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            //             printWin.document.write('<br><br><br><br><br>');
            //             printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            //             printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[2].Nombre + ' '+ UsuariosFirmas[2].ApPaterno + ' '+ UsuariosFirmas[2].ApMaterno + '</strong></label><div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('       <div class="align-self-center">');
            //             printWin.document.write('           <label><strong>' + UsuariosFirmas[2].Area + '</strong></label></div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('</div>');
            //             printWin.document.write('</div>');
            //             break;
            //         }
            //     case 4: 
            //         {
            //             printWin.document.write('<div class="row">');
            //             printWin.document.write('<div class="form-group col-1"></div>');
            //             printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            //             printWin.document.write('<br><br><br><br><br>');
            //             printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            //             printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[0].Nombre + ' '+ UsuariosFirmas[0].ApPaterno + ' '+ UsuariosFirmas[0].ApMaterno + '</strong></label><div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('       <div class="align-self-center">');
            //             printWin.document.write('           <label><strong>' + UsuariosFirmas[0].Area + '</strong></label></div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('</div>');
            //             printWin.document.write('<div class="form-group col-2"></div>');
            //             printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            //             printWin.document.write('<br><br><br><br><br>');
            //             printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            //             printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[1].Nombre + ' '+ UsuariosFirmas[1].ApPaterno + ' '+ UsuariosFirmas[1].ApMaterno + '</strong></label><div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('       <div class="align-self-center">');
            //             printWin.document.write('           <label><strong>' + UsuariosFirmas[1].Area + '</strong></label></div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('</div>');
            //             printWin.document.write('<div class="form-group col-1"></div>');
            //             printWin.document.write('</div>');
            //             printWin.document.write('<div class="row">');
            //             printWin.document.write('<div class="form-group col-1"></div>');
            //             printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            //             printWin.document.write('<br><br><br><br><br>');
            //             printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            //             printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[2].Nombre + ' '+ UsuariosFirmas[2].ApPaterno + ' '+ UsuariosFirmas[2].ApMaterno + '</strong></label><div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('       <div class="align-self-center">');
            //             printWin.document.write('           <label><strong>' + UsuariosFirmas[2].Area + '</strong></label></div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('</div>');
            //             printWin.document.write('<div class="form-group col-2"></div>');
            //             printWin.document.write('<div class="form-group col-4 align-self-center" style="border: 1px solid black";>');
            //             printWin.document.write('<br><br><br><br><br>');
            //             printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            //             printWin.document.write('           <div class="align-self-center"><label><strong>' + UsuariosFirmas[3].Nombre + ' '+ UsuariosFirmas[3].ApPaterno + ' '+ UsuariosFirmas[3].ApMaterno + '</strong></label><div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('       <div class="align-self-center">');
            //             printWin.document.write('           <label><strong>' + UsuariosFirmas[3].Area + '</strong></label></div>');
            //             printWin.document.write('       </div>');
            //             printWin.document.write('</div>');
            //             printWin.document.write('<div class="form-group col-1"></div>');
            //             printWin.document.write('</div>');
            //             break;
            //         }
            // }
            // printWin.document.write('</div>');
            printWin.document.write('</div>');
 
            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        ImprimirSolicitud(solicitud, usrArchivo)
        {
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-12 padding-div-low">');
            printWin.document.write('<div class="area"><br><br>');
            printWin.document.write('<div class="row">');
            printWin.document.write('   <div class="form-group col-1"></div>');
            printWin.document.write('   <div class="form-group col-3 align-self-center">');
            printWin.document.write('       <img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/>');
            printWin.document.write('   </div>');
            printWin.document.write('   <div class="form-group col-4 text-center align-self-center">');
            printWin.document.write('           <h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5>');
            printWin.document.write('   </div>');
            printWin.document.write('   <div class="form-group col-4"></div>');
            printWin.document.write('</div>');
            printWin.document.write('<div class="row" >');
            printWin.document.write('   <div class="form-group col-12 align-self-center">');
            printWin.document.write('       <div class="text-center">');
            printWin.document.write('           <h5 class="text-center">SOLICITUD DE DOCUMENTO</h5></div></div></div><br>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('   <div class="form-group col-10 text-right"><label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label></div>');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('</div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 text-center">');
            printWin.document.write('   <h5>Datos de la Solicitud</h5>');
            printWin.document.write('</div>');
            printWin.document.write('</div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('   <div class="form-group col-2"><label><strong>Solicitud # : </strong></label></div>');
            printWin.document.write('   <div class="form-group col-3" ><label>'+ solicitud.SolicitudDocumentoId +'</label></div>');
            printWin.document.write('   <div class="form-group col-2"><label><strong>Fecha de Registro: </strong></label></div>');
            printWin.document.write('   <div class="form-group col-3" ><label>'+ solicitud.FechaRegistro  +'</label></div>');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('</div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('   <div class="form-group col-2"><label><strong>Observaciones : </strong></label></div>');
            printWin.document.write('   <div class="form-group col-8" ><label>'+ solicitud.ObservacionesArchivo +'</label></div>');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('</div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('   <div class="form-group col-12 text-center">');
            printWin.document.write('       <h5>Datos del Solicitante</h5>');
            printWin.document.write('   </div>');
            printWin.document.write('</div>');
             
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('   <div class="form-group col-2" ><label><strong>Nombre : </strong></label></div>');
            printWin.document.write('   <div class="form-group col-8" ><label>'+ solicitud.Juzgado.UsuarioIdQuienSolicita.Nombre + " "  + solicitud.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno + " " + solicitud.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno +'</label></div>');
            printWin.document.write('   <div class="form-group col-1"></div>');
            printWin.document.write('</div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('   <div class="form-group col-2" ><label><strong>Area : </strong></label></div>');
            printWin.document.write('   <div class="form-group col-8" ><label>'+ solicitud.Juzgado.AreaIdQueSolicita.Nombre +'</label></div>');
            printWin.document.write('   <div class="form-group col-1"></div>');
            printWin.document.write('</div>');
          
            printWin.document.write('<div class="row">');
            printWin.document.write('   <div class="form-group col-12 text-center">');
            printWin.document.write('       <h5>Datos del Documento</h5>');
            printWin.document.write('   </div>');
            printWin.document.write('</div>');

            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('   <div class="form-group col-1"><label><strong>Área : </strong></label></div>');
            printWin.document.write('   <div class="form-group col-4" ><label>'+ solicitud.InventarioDocumentos.Area.Nombre +'</label></div>');
            printWin.document.write('   <div class="form-group col-1"><label><strong>Tipo : </strong></label></div>');
            printWin.document.write('   <div class="form-group col-4" ><label>'+ solicitud.InventarioDocumentos.TipoDocumento.Nombre +'</label></div>');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('</div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('   <div class="form-group col-1"><label><strong>Año : </strong></label></div>');
            printWin.document.write('   <div class="form-group col-4" ><label>'+ solicitud.InventarioDocumentos.Anio +'</label></div>');
            printWin.document.write('   <div class="form-group col-2"><label><strong>Consecutivo : </strong></label></div>');
            printWin.document.write('   <div class="form-group col-3" ><label>'+ solicitud.InventarioDocumentos.Consecutivo +'</label></div>');
            printWin.document.write('<div class="form-group col-1"></div>');
            printWin.document.write('</div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 text-center">');
            printWin.document.write('    <h5>Volumenes del Documento</h5>');
            printWin.document.write('</div>');
            printWin.document.write('</div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('   <div class="form-group col-2"></div>');
            printWin.document.write('   <div class="form-group col-8">');
            printWin.document.write('       <div class="table-reponsive">');
            printWin.document.write('           <table class="table table-striped table-light table-hover">');
            printWin.document.write('               <thead class="thead-dark">');
            printWin.document.write('                   <tr><th>No. de Volumen</th><th>No. de Fojas</th><th>Ubicación</th></tr>');
            printWin.document.write('               </thead>');
            printWin.document.write('               <tbody class="text-dark">');
            //ciclo inicio
            $.each(solicitud.VolumenesEnSolicitud, function(index, volumenes){
                printWin.document.write('                   <tr>');
                printWin.document.write('                       <td>'+ volumenes.Volumenes.NumVolumen+'</td>');
                printWin.document.write('                       <td>' + volumenes.Volumenes.Fojas + '</td>');
                printWin.document.write('                       <td>' + volumenes.Volumenes.Area.Nombre + '</td>');
                printWin.document.write('                   </tr>');
            });
            //ciclo fin
            printWin.document.write('               </tbody>');
            printWin.document.write('           </table>');
            printWin.document.write('       </div>');
            printWin.document.write('   </div>');
            printWin.document.write('   <div class="form-group col-2"></div>');
            printWin.document.write('</div><br>');

            printWin.document.write('<div class="row">');
            printWin.document.write('   <div class="form-group col-1"></div>');
            printWin.document.write('   <div class="form-group col-4 align-self-center" style="border: 1px solid black;">');
            printWin.document.write('       <br><br><br><br><br>');
            printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            printWin.document.write('           <div class="align-self-center"><label><strong>'+ usrArchivo.Nombre + ' ' + usrArchivo.ApellidoPaterno + ' ' + usrArchivo.ApellidoMaterno +  '</strong></label><div>');
            printWin.document.write('       </div>');
            printWin.document.write('       <div class="align-self-center">');
            printWin.document.write('           <label><strong>Dirección del Archivo Judicial</strong></label></div>');
            printWin.document.write('       </div>');
            printWin.document.write('   </div>'); 
            printWin.document.write('   <div class="form-group col-2"></div>');
            printWin.document.write('   <div class="form-group col-4 align-self-center" style="border: 1px solid black;">');
            printWin.document.write('       <br><br><br><br><br>');
            printWin.document.write('       <div class="align-self-center text-center" style="border-top: 1px solid black; "');
            printWin.document.write('           <div class="align-self-center"><label><strong>' + solicitud.Juzgado.UsuarioIdQuienSolicita.Nombre + " "  + solicitud.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno + " " + solicitud.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno + '</strong></label>');
            printWin.document.write('       </div>');
            printWin.document.write('       <div class="align-self-center text-center">');
            printWin.document.write('           <label><strong>' + solicitud.Juzgado.AreaIdQueSolicita.Nombre + '</strong></label>');
            printWin.document.write('       </div>');
            printWin.document.write('   </div>');            
            printWin.document.write('   <div class="form-group col-1"></div>');
            printWin.document.write('</div>');
            printWin.document.write('</div></div>');
            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        ImprimirVale(datos){
            var ListadoVales = [];
            ListadoVales.push(datos)//this.Solicitudes;
            
            let _this =this;
            if(ListadoVales.length>0)
            {
                var TotalSolicitudes = ListadoVales.length;
                var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
                printWin.document.open();
                printWin.document.write('<html><head><title>Archivo Judicial</title>');
                printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
                printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
                printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
                printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
                printWin.document.write('</head><body>');
                for (var i = 0; i < TotalSolicitudes; i++) {
                printWin.document.write('<div class="col-12 padding-div-low" style="display: block; page-break-before: always;">');
                printWin.document.write('<div class="area"><br><br>');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-3 align-self-center">');
                printWin.document.write('       <img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/>');
                printWin.document.write('   </div>');
                printWin.document.write('   <div class="form-group col-6 text-center align-self-center">');
                printWin.document.write('           <h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5>');
                printWin.document.write('   </div>');
                printWin.document.write('   <div class="form-group col-3"></div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row" >');
                printWin.document.write('   <div class="form-group col-12 align-self-center">');
                printWin.document.write('       <div class="text-center">');
                printWin.document.write('           <h5 class="text-center">SOLICITUD DE DOCUMENTO</h5></div></div></div><br>');
                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-12 text-right"><label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label></div>');
   
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('<div class="form-group col-12 text-center">');
                printWin.document.write('   <h5>Datos de la Solicitud</h5>');
                printWin.document.write('</div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Solicitud # : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ ListadoVales[i].SolicitudDocumentoId +'</label></div>');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Fecha de Registro: </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ moment(ListadoVales[i].FechaRegistro).format('DD/MM/YYYY')  +'</label></div>');

                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Observaciones : </strong></label></div>');
                var ArchivoObservaciones= "";
                if(ListadoVales[i].ObservacionesArchivo!=null)
                {
                    ArchivoObservaciones = ListadoVales[i].ObservacionesArchivo
                }
                printWin.document.write('   <div class="form-group col-10" ><label>'+ ArchivoObservaciones +'</label></div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-12 text-center">');
                printWin.document.write('       <h5>Datos del Solicitante</h5>');
                printWin.document.write('   </div>');
                printWin.document.write('</div>');
                
                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-2" ><label><strong>Nombre : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-10" ><label>'+ ListadoVales[i].Juzgado.UsuarioIdQuienSolicita.Nombre + " "  + ListadoVales[i].Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno + " " + ListadoVales[i].Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno +'</label></div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-2" ><label><strong>Area : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-10" ><label>'+ ListadoVales[i].Juzgado.AreaIdQueSolicita.Nombre +'</label></div>');
                printWin.document.write('</div>');
            
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-12 text-center">');
                printWin.document.write('       <h5>Datos del Documento</h5>');
                printWin.document.write('   </div>');
                printWin.document.write('</div>');

                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-2"><label><strong>Tipo : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ ListadoVales[i].InventarioDocumentos.TipoDocumento.Nombre +'</label></div>');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Consecutivo : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ ListadoVales[i].InventarioDocumentos.Consecutivo + '/'+ ListadoVales[i].InventarioDocumentos.Anio +'</label></div>');

                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('<div class="form-group col-12 text-center">');
                printWin.document.write('    <h5>Volumenes del Documento</h5>');
                printWin.document.write('</div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                
                printWin.document.write('   <div class="form-group col-12">');
                printWin.document.write('       <div class="table-reponsive">');
                printWin.document.write('           <table class="table table-striped table-hover table-sm">');
                printWin.document.write('               <thead class="thead-dark">');
                printWin.document.write('                   <tr><th>No.</th><th>Fojas</th><th>Ubicación</th><th>Contenido</th></tr>');
                printWin.document.write('               </thead>');
                printWin.document.write('               <tbody class="text-dark">');
                //ciclo inicio
                $.each(ListadoVales[i].VolumenesEnSolicitud, function(index, volumenes){

                        printWin.document.write('                   <tr>');
                        printWin.document.write('                       <td width = "30">'+ volumenes.Volumenes.NumVolumen+'</td>');
                        var fojas ="";
                        if(volumenes.Volumenes.Fojas!= 0)
                        {
                            fojas = volumenes.Volumenes.Fojas;
                        }

                        printWin.document.write('                       <td width = "50" >' + fojas + '</td>');
                        printWin.document.write('                       <td width = "150" >' + volumenes.Volumenes.Area.Nombre + '</td>');
                        printWin.document.write('<td width = "700" >' + _this.DesglosaParaImpresion(volumenes.Volumenes) + '</td>')
                        printWin.document.write('                   </tr>');
                });
                //ciclo fin
                printWin.document.write('               </tbody>');
                printWin.document.write('           </table>');
                printWin.document.write('       </div>');
                printWin.document.write('   </div>');
                
                printWin.document.write('</div>');

                if(ListadoVales[i].IncidentesEnSolicitud.length>0)
                {
                    printWin.document.write('<div class="row">');
                    printWin.document.write('<div class="form-group col-12 text-center">');
                    printWin.document.write('    <h5>Incidentes del Documento</h5>');
                    printWin.document.write('</div>');
                    printWin.document.write('</div>');
                    printWin.document.write('<div class="row">');
                    
                    printWin.document.write('   <div class="form-group col-12">');
                    printWin.document.write('       <div class="table-reponsive">');
                    printWin.document.write('           <table class="table table-striped table-light table-hover table-sm">');
                    printWin.document.write('               <thead class="thead-dark">');
                    printWin.document.write('                   <tr><th>No. de Incidente</th><th>Tipo</th><th>Ubicación</th></tr>');
                    printWin.document.write('               </thead>');
                    printWin.document.write('               <tbody class="text-dark">');
                    //ciclo inicio
                    $.each(ListadoVales[i].IncidentesEnSolicitud, function(index, Incidentes){
                        printWin.document.write('                   <tr>');
                        printWin.document.write('                       <td>'+ Incidentes.Incidentes.NumeroIncidente+'</td>');
                        printWin.document.write('                       <td>' + Incidentes.Incidentes.TipoIncidente + '</td>');
                        printWin.document.write('                       <td>' + Incidentes.Incidentes.Area.Nombre + '</td>');
                        printWin.document.write('                   </tr>');
                    });
                    //ciclo fin
                    printWin.document.write('               </tbody>');
                    printWin.document.write('           </table>');
                    printWin.document.write('       </div>');
                    printWin.document.write('   </div>');
                    
                    printWin.document.write('</div>');
                };

                if(ListadoVales[i].TerceriasEnSolicitud.length>0)
                {
                    printWin.document.write('<div class="row">');
                    printWin.document.write('<div class="form-group col-12 text-center">');
                    printWin.document.write('    <h5>Tercerías del Documento</h5>');
                    printWin.document.write('</div>');
                    printWin.document.write('</div>');
                    printWin.document.write('<div class="row">');
                    
                    printWin.document.write('   <div class="form-group col-12">');
                    printWin.document.write('       <div class="table-reponsive">');
                    printWin.document.write('           <table class="table table-striped table-light table-hover table-sm">');
                    printWin.document.write('               <thead class="thead-dark">');
                    printWin.document.write('                   <tr><th>No. de Tercería</th><th>Tipo</th><th>Ubicación</th></tr>');
                    printWin.document.write('               </thead>');
                    printWin.document.write('               <tbody class="text-dark">');
                    //ciclo inicio
                    $.each(ListadoVales[i].TerceriasEnSolicitud, function(index, Tercerias){
                        printWin.document.write('                   <tr>');
                        printWin.document.write('                       <td>'+ Tercerias.Tercerias.NumeroTerceria +'</td>');
                        printWin.document.write('                       <td>' + Tercerias.Tercerias.TipoTerceria + '</td>');
                        printWin.document.write('                       <td>' + Tercerias.Tercerias.Area.Nombre + '</td>');
                        printWin.document.write('                   </tr>');
                    });
                    //ciclo fin
                    printWin.document.write('               </tbody>');
                    printWin.document.write('           </table>');
                    printWin.document.write('       </div>');
                    printWin.document.write('   </div>');
                    
                    printWin.document.write('</div>');
                };
                printWin.document.write('<div style="page-break-inside: avoid; page-break-after: auto" >');//prueba
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-12" style="border-style: dotted; border-width: 4px;">');
                printWin.document.write('           <label>PARA USO EXCLUSIVO DEL ARCHIVO</label>');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label>Ubicación:</label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label>Numero de Hojas:</label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label>Entregó:</label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label>Anexos:</label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label>Fecha de Devolución:</label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label>Recibió:</label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                printWin.document.write('</div>'); // prueba
                

                printWin.document.write('</div></div>');
            }
            printWin.document.write('</body></html>');

            var css = '@page { size: Letter;  margin: 15mm 15mm 15mm 15mm; }',
            head = printWin.document.head || document.getElementsByTagName('head')[0],
            style = printWin.document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet) {
            style.styleSheet.cssText = css;
            } else {
            style.appendChild(printWin.document.createTextNode(css));
            }
            head.appendChild(style);
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
            }
            else
            {
                comun.mensajeDeAlerta("Seleccione una o varias Solicitudes para Autorizar", null, null);
            }
        },
        ImprimirAcuse(datos, usrArchivo){
            let NombreFirma = this.SecretarioAcuerdos;
            let PuestoFirma = this.PuestoFirma;
            var Listado =[];
            Listado.push(datos);
            var UsuariosFirmas =[];
            let _this= this;
            UsuariosFirmas.push({"Nombre": usrArchivo.Nombre, "ApPaterno": usrArchivo.ApellidoPaterno, "ApMaterno": usrArchivo.ApellidoMaterno, "Area": usrArchivo.AreaAsignado.Nombre});
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">LISTADO DE SOLICITUDES AUTORIZADAS</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h6 class="text-center">ENTREGA DE DOCUMENTOS</h6>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 text-right">');
            printWin.document.write('<label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 ">');
            printWin.document.write('<label>Area: '+ this.AreaEtiqueta +'</label>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12" style="display: block; page-break-before: auto;">');
            printWin.document.write('<div class="table-reponsive">');
            printWin.document.write('<table class="table table-striped table-light table-bordered table-sm">');
            printWin.document.write('<thead><tr><th >No.</th><th >Documento</th><th >Consecutivo</th><th >Solicitado por:</th>');
            printWin.document.write('<th>Observaciones</th><th>Contenido en Solicitud</th></tr></thead><tbody class="text-dark">');
            //ciclo inicio
            $.each(Listado, function(index, SolicitudesImpresion){

                var Detalle = SolicitudesImpresion.ObservacionesArchivo !=null ? SolicitudesImpresion.ObservacionesArchivo : "";
                if(Detalle!="")
                {
                    Detalle=Detalle + "<br/>";
                };
                
                printWin.document.write('<tr>');
                printWin.document.write('<td width="30">'+ SolicitudesImpresion.SolicitudDocumentoId +'</td>');
                printWin.document.write('<td width="200">'+ SolicitudesImpresion.InventarioDocumentos.TipoDocumento.Nombre +'</td>');
                printWin.document.write('<td width="50">'+ SolicitudesImpresion.InventarioDocumentos.Consecutivo +'/' + SolicitudesImpresion.InventarioDocumentos.Anio +'</td>');
                printWin.document.write('<td width="200">'+ SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre
                                              + ' ' + SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno
                                              + ' ' + SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno +'</td>');
                printWin.document.write('<td width="150">'+ Detalle +'</td>');
                printWin.document.write('<td width="200">'+ _this.DesglosaContenido(SolicitudesImpresion) +'</td>');
                printWin.document.write('</tr>');
                var Existe = UsuariosFirmas.findIndex(datos => datos.Nombre == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre &&
                                                    datos.ApPaterno == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno &&
                                                    datos.ApMaterno == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno);
                if(Existe == -1)
                    {
                        UsuariosFirmas.push({
                                "Nombre": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre,
                                "ApPaterno": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno,
                                "ApMaterno": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno,
                                "Area": SolicitudesImpresion.Juzgado.AreaIdQueSolicita.Nombre
                                            });
                    }

            });
            //ciclo fin

            printWin.document.write('</tbody></table></div></div></div>');
            printWin.document.write('<div class="area" style="display: block; page-break-after: avoid;">');
            

                        
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('<div class="row">');
                        printWin.document.write('   <div class="form-group col-5" style="border-top: 1px solid black";>');// style="border: 1px solid black";>');
                        printWin.document.write('       <div class="text-center">');
                        printWin.document.write('           <label><strong>'+ ( NombreFirma!=null ? NombreFirma : "") + '</strong></label>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="text-center">');
                        printWin.document.write('           <label><strong>'+(PuestoFirma!=null ? PuestoFirma : "PRIMER SECRETARIO DE ACUERDOS") + '</strong></label>');
                        printWin.document.write('       </div>');
                        printWin.document.write('   </div>');
                        printWin.document.write('   <div class="form-group col-2" ></div>')
                        printWin.document.write('   <div class="form-group col-5" style="border-top: 1px solid black";>');// style="border: 1px solid black";>');
                        printWin.document.write('       <div class="text-center">');
                        printWin.document.write('           <label><strong>SELLO</strong></label>');
                        printWin.document.write('       </div>');
                        // printWin.document.write('       <div class="text-center">');
                        // printWin.document.write('           <label><strong>' + ( this.SecretarioAcuerdo!=null ? this.SecretarioAcuerdo.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre.toUpperCase() : "") +'</label>');
                        // printWin.document.write('       </div>');
                        printWin.document.write('   </div>');

                        printWin.document.write('</div>');
           
            printWin.document.write('</div>');
            printWin.document.write('</div>');

            printWin.document.write('</body></html>');
            var css = '@page { size: Letter;  margin: 15mm 15mm 15mm 15mm; }',
            head = printWin.document.head || document.getElementsByTagName('head')[0],
            style = printWin.document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet) {
            style.styleSheet.cssText = css;
            } else {
            style.appendChild(printWin.document.createTextNode(css));
            }
            head.appendChild(style);
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();

        },
        Anexos(datos){
            this.idModal = datos.SolicitudDocumentoId;
            this.ObsModal = datos.ObservacionesArchivo;
            this.Arch_Observaciones = true;
        },
        DesglosaParaImpresion: function (datos) {
            
            let Contenido ="";
            Contenido = Contenido + "<b>TOMO NO. " + datos.NumVolumen + "</b><br/>" ;                       
            return Contenido;
        },
        DesglosaContenido: function (datos){
            
            let Contenido ="";
            if(datos.VolumenesEnSolicitud.length>0)
            {   
                $.each(datos.VolumenesEnSolicitud, function(index, Listado)
                { 
                    Contenido = Contenido + "<b >TOMO NO. :</b>" + Listado.Volumenes.NumVolumen + "<br/>"   
                });
            };
            if(datos.IncidentesEnSolicitud.length>0)
            {
                $.each(datos.IncidentesEnSolicitud, function(index, enVolumen)
                {
                    Contenido = Contenido + "<b>INCIDENTE NO :</b>" + enVolumen.Incidentes.NumeroIncidente + "<br/>";
                });
            }
            if(datos.TerceriasEnSolicitud.length>0)
            {
                var lineaTexto ="";
                
                
                $.each(datos.TerceriasEnSolicitud, function(index, enVolumen)
                {
                    
                        Contenido = Contenido + "<b >TERCERIA NO. :</b>"+ enVolumen.Tercerias.NumeroTerceria  + "<br/>";
                    
                })
            }
            return Contenido;
        },
        EstatusObservaciones(valor) {
            this.Arch_Observaciones = valor.Estatus;
            this.ListadoSolicitudes.find(id=>id.SolicitudDocumentoId==valor.Id).ObservacionesArchivo= valor.Texto;
        },
        GenerarPrintVales (Listado, usrArchivo){
            let NombreFirma = this.SecretarioAcuerdos;
            let PuestoFirma = this.PuestoFirma;
            var ListaAImprmir = Listado.filter(x=>x.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId!=1);
            var UsuariosFirmas =[];
            let _this= this;
            UsuariosFirmas.push({"Nombre": usrArchivo.Nombre, "ApPaterno": usrArchivo.ApellidoPaterno, "ApMaterno": usrArchivo.ApellidoMaterno, "Area": usrArchivo.AreaAsignado.Nombre});
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">LISTADO DE SOLICITUDES AUTORIZADAS</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h6 class="text-center">ENTREGA DE DOCUMENTOS</h6>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 text-right">');
            printWin.document.write('<label>Aguascalientes, Ags., a  '+ moment(this.Busqueda.Fecha).format('DD/MM/YYYY') + '</label>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 ">');
            printWin.document.write('<label>Area: '+ this.AreaEtiqueta +'</label>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12" style="display: block; page-break-before: auto;">');
            printWin.document.write('<div class="table-reponsive">');
            printWin.document.write('<table class="table table-striped table-light table-bordered table-sm">');
            printWin.document.write('<thead><tr><th >No.</th><th >Documento</th><th >Consecutivo</th><th >Solicitado por:</th>');
            printWin.document.write('<th>Observaciones</th></tr></thead><tbody class="text-dark">');
            //ciclo inicio
            $.each(ListaAImprmir, function(index, SolicitudesImpresion){

                var Detalle = SolicitudesImpresion.ObservacionesArchivo !=null ? SolicitudesImpresion.ObservacionesArchivo : "";
                if(Detalle!="")
                {
                    Detalle=Detalle + "<br/>";
                };
                printWin.document.write('<tr>');
                printWin.document.write('<td width="30">'+ SolicitudesImpresion.SolicitudDocumentoId +'</td>');
                printWin.document.write('<td width="200">'+ SolicitudesImpresion.InventarioDocumentos.TipoDocumento.Nombre +'</td>');
                printWin.document.write('<td width="50">'+ SolicitudesImpresion.InventarioDocumentos.Consecutivo +'/' + SolicitudesImpresion.InventarioDocumentos.Anio +'</td>');
                printWin.document.write('<td width="200">'+ SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre
                                              + ' ' + SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno
                                              + ' ' + SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno +'</td>');
                printWin.document.write('<td width="350">'+ Detalle +'</td>');
                //printWin.document.write('<td width="200">'+ _this.DesglosaContenido(SolicitudesImpresion) +'</td>');
                printWin.document.write('</tr>');
                var Existe = UsuariosFirmas.findIndex(datos => datos.Nombre == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre &&
                                                    datos.ApPaterno == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno &&
                                                    datos.ApMaterno == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno);
                if(Existe == -1)
                    {
                        UsuariosFirmas.push({
                                "Nombre": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre,
                                "ApPaterno": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno,
                                "ApMaterno": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno,
                                "Area": SolicitudesImpresion.Juzgado.AreaIdQueSolicita.Nombre
                                            });
                    }

            });
            //ciclo fin

            printWin.document.write('</tbody></table></div></div></div>');
            printWin.document.write('<div class="area" style="display: block; page-break-after: avoid;">');
            
            
                        
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('<div class="row">');
                        printWin.document.write('   <div class="form-group col-5" style="border-top: 1px solid black";>');// style="border: 1px solid black";>');
                        printWin.document.write('       <div class="text-center">');
                        printWin.document.write('           <label><strong>'+ ( NombreFirma!=null ? NombreFirma : "") + '</strong></label>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="text-center">');
                        printWin.document.write('           <label><strong>'+(PuestoFirma!=null ? PuestoFirma : "PRIMER SECRETARIO DE ACUERDOS") + '</strong></label>');
                        printWin.document.write('       </div>');
                        printWin.document.write('   </div>');
                        printWin.document.write('   <div class="form-group col-2" ></div>')
                        printWin.document.write('   <div class="form-group col-5" style="border-top: 1px solid black";>');// style="border: 1px solid black";>');
                        printWin.document.write('       <div class="text-center">');
                        printWin.document.write('           <label><strong>SELLO</strong></label>');
                        printWin.document.write('       </div>');
                        // printWin.document.write('       <div class="text-center">');
                        // printWin.document.write('           <label><strong>' + ( this.SecretarioAcuerdo!=null ? this.SecretarioAcuerdo.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre.toUpperCase() : "") +'</label>');
                        // printWin.document.write('       </div>');
                        printWin.document.write('   </div>');

                        printWin.document.write('</div>');
           
            printWin.document.write('</div>');
            printWin.document.write('</div>');

            printWin.document.write('</body></html>');
            var css = '@page { size: Letter;  margin: 15mm 15mm 15mm 15mm; }',
            head = printWin.document.head || document.getElementsByTagName('head')[0],
            style = printWin.document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet) {
            style.styleSheet.cssText = css;
            } else {
            style.appendChild(printWin.document.createTextNode(css));
            }
            head.appendChild(style);
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
    },
    mounted(){
        //this.ObtieneArea();
        this.usrConsulta = this.$store.state.Login_Usuario; 
    }
}
</script>

<style scoped>
    input[type="text"]:read-only {
        background: #f3f3f3;
    }
    input[type="text"]:read-only:focus {
        color: #fff;
    }
    textarea[type="text"]:read-only {
        background: #504f54;
    }    
    textarea[type="text"]:read-only:focus {
        color: #fff;
    }
    .thead-custom {
        background-color: #004746;
        color: white;
    }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Solicitudes/ConsultaSolicitud.vue